import TreatmentPage from "./TreatmentPage";

export default function PRPTreatment() {
  return (
    <TreatmentPage
      title="Platelet-Rich Plasma"
      heroImage="/Treatment/prp-drtruptis-clinic.jpg"
      intro="Platelet-Rich Plasma (PRP) hair treatment is a non-surgical, 30-minute procedure using a patient’s own blood, processed to concentrate platelets and injected into the scalp to stimulate dormant follicles, reduce thinning, and promote hair growth."
      description="It is the best treatment for acne scar also."
      howItWorks="Platelets release growth factors that boost blood circulation, strengthen hair, and revive hair follicles."
      benefits={[
        "Promotes hair growth.",
        "Stop hair thinning.",
        "Strength to hair root and follicle.",
      ]}
      beforeAfterImages={[
        "/Treatment/before-prp-drtruptis-clinic.jpeg",
        "/Treatment/after-prp-drtruptis-clinic.jpeg",
      ]}
      faqs={[
        { q: "Is it painful?", a: "Mild discomfort only, done under cooling gel." },
        { q: "How many sessions needed?", a: "Usually 4-6 sessions." },
      ]}
    />
  );
}
